import React, {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {deleteMetricService, reset,} from "./redux/slice";
import Modal, {ModalBody, ModalFooter} from "Components/Modal";
import {Button} from 'Components';
import {useIntl} from "react-intl";
import {NotificationManager} from "../../../../../../components/Notifications";

//Styles
import './styles.scss'
import {Typography} from "@mui/material";
import {convertToKPH} from "Core/data/Helpers";

const DeleteMetric = (props) => {
    const {refresh} = props;
    const dispatch = useDispatch();
    const {messages} = useIntl();
    const {
        metrics,
        error,
        deleteMetricResult,
        open
    } = useSelector((state) => state.manageDeleteMetricServiceRedux);

    const user = useSelector((state) => state.securityRedux.user);
    const handleClose = useCallback(() => {
        dispatch(reset({open: false, deleteMetricResult: null}));
    }, []);

    const handleSuccess = useCallback((message) => {
        NotificationManager.success(
            messages[message],
            messages["success"],
            3000,
            null,
            null,
            "success"
        );
        refresh();
        handleClose();
    }, []);

    useEffect(() => {
        if (deleteMetricResult) {
            handleSuccess(`deletedBehavior_deletedMetric_success`);
        }
    }, [deleteMetricResult]);


    useEffect(() => {
        if (error) {
            NotificationManager.error(
                error?.error || messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({error: null}));
        }
    }, [error]);

    return (
        <Modal
            title={messages['deletedBehavior_deletedMetric']}
            open={open}
            position="right"
            size="small"
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{padding: 24, height: 450}}>

                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages['deletedBehavior_metricsMessage']}
                    </Typography>
                    <div style={{marginTop: 24}}>
                        {
                            (metrics && metrics?.length) &&
                            <ul>
                                {
                                    metrics.map((row, key) => {
                                        return (
                                            <li key={key}>
                                                <span>
                                                    {
                                                        row.category === 'vehicleSpeed' && (
                                                            <>
                                                                {`${messages['behavior_' + row.metric]} ${row.metricValue ? (user.isKph ? convertToKPH(row.metricValue) : row.metricValue) : 'e'}`}
                                                                <Button
                                                                    type="icon"
                                                                    icon="info"
                                                                    style={{fontSize: '15px'}}
                                                                    tooltip={row.metricValue === 100 ?
                                                                        messages['behavior_tooltip_speedLabelFinal' + (user.isKph ? 'Kph' : '')] : `${messages['behavior_tooltip_speedLabel']} ${row.metricValue ?
                                                                            (user.isKph ? convertToKPH(row.metricValue) : row.metricValue) : ''} ${messages['behavior_tooltip_speedLabelComplement']} ${row.metricValue ?
                                                                            (user.isKph ? convertToKPH(row.metricValue + 5) : row.metricValue + 5) : ''}`}
                                                                    onClick={() => {
                                                                    }}
                                                                    className="icon-weights-info"
                                                                />
                                                            </>
                                                        )
                                                    }
                                                    {
                                                        !['vehicleSpeed', 'speedingOverPosted'].includes(row.category) && (
                                                            <>
                                                                {`${messages['behavior_' + row.metric]} ${row.metricValue ? row.metricValue : ''}`}
                                                                <Button
                                                                    type="icon"
                                                                    icon="info"
                                                                    style={{fontSize: '15px'}}
                                                                    tooltip={messages['behavior_tooltip_' + row.metric]}
                                                                    onClick={() => {
                                                                    }}
                                                                    className="icon-weights-info"
                                                                />
                                                            </>
                                                        )
                                                    }
                                                    {
                                                        row.category === 'speedingOverPosted' && (
                                                            <>
                                                                {`${messages['behavior_' + row.metric + (user.isKph ? 'Kph' : '')]}`}
                                                                <Button
                                                                    type="icon"
                                                                    icon="info"
                                                                    style={{fontSize: '15px'}}
                                                                    tooltip={messages['behavior_' + row.metric + (user.isKph ? 'Kph' : '')]}
                                                                    onClick={() => {
                                                                    }}
                                                                    className="icon-weights-info"
                                                                />
                                                            </>
                                                        )
                                                    }
                                                </span>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        }
                    </div>
                </div>
            </ModalBody>

            <ModalFooter style={{boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)"}}>
                <Button
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    onClick={(e) => {
                        if (metrics.length > 1) {
                            dispatch(deleteMetricService({metrics}))
                        } else {
                            dispatch(deleteMetricService({id: metrics[0].id}))
                        }
                    }}
                    className="btn-red"
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteMetric
